export default "__VITE_ASSET__BQUEy$Fh__"